export default __webpack_public_path__ + "static/media/yellow-standing-raccoon.dae65560.jpg";